/**
 * moreDirectory.js — the ONE structure of the mobile "More" directory.
 * Every item references a navRegistry id (canonical route); labels here are the short child-facing words
 * the owner approved (Oct 2026). Age filtering uses the registry `age` tiers — discovery only, never a lock.
 */
import { routeById } from "@/lib/navRegistry";

const item = (id, label, emoji) => {
  const r = routeById(id);
  if (!r) throw new Error(`moreDirectory: unknown registry id ${id}`);
  return { id, to: r.to, label: label || r.label, emoji: emoji || "", age: r.age || null, audience: r.audience };
};

export const MORE_TOP = [item("find", "Search", "🔎"), { id: "travel", to: "/travel", label: "Travel Mode", emoji: "✈️", age: null, audience: "child" }];

export const MORE_SECTIONS = [
  { id: "learning", emoji: "📚", title: "Learning", items: [
    item("learn-pathways", "Pathways"), item("subjects", "Subjects"), item("learn-topics", "Topics"), item("curriculum", "Curriculum"),
    item("quest-academy", "Academies"), item("stories", "Reading & Stories"),
  ] },
  { id: "play", emoji: "🎮", title: "Play & Create", items: [
    item("games", "Games"), item("puzzles", "Puzzles"), item("quick-rounds", "Quick Rounds"), item("create", "Creative"),
  ] },
  { id: "discover", emoji: "🌍", title: "Discover", items: [
    item("countries", "Countries"), item("wonders", "Wonders"), item("animals", "Animals & Nature"), item("world-trip", "World Trip Planner"),
  ] },
  { id: "myworld", emoji: "🎒", title: "My World", items: [
    item("passport", "Passport"), item("portfolio", "Portfolio"), item("certificates", "Certificates"), item("learning-plan", "Learning Plan"),
  ] },
];

export const MORE_SINGLES = [item("surprise", "Surprise Me", "✨"), item("everything", "Everything", "📖")];

export const MORE_GROWNUPS = item("grown-ups", "Grown-up Mode", "👨‍👩‍👧");

export const MORE_FOOTER = [item("help", "Help", "❓"), item("safety", "Safety & Privacy", "🛡️")];

/** Items visible for a tier (null tier = neutral: show everything child-facing). Adult items are never age-filtered. */
export const visibleFor = (items, tier) => items.filter((i) => !tier || i.audience === "adult" || !i.age || i.age.includes(tier));

/** Search chips used by /find when the box is empty — canonical registry routes only. */
export const FIND_POPULAR = [
  { label: "Maths", to: "/start/maths", emoji: "➗" }, item("games", "Games", "🎮"), item("countries", "Countries", "🌍"), item("stories", "Stories", "📖"),
  item("live-quest", "Live Today", "⚡"), item("passport", "Passport", "🎒"), item("create", "Create", "🎨"), item("subjects", "Subjects", "🗂️"),
];
